module.exports = __webpack_public_path__ + "static/media/white-chocolate-macadamia.e32e4666.png";